// @ts-nocheck

import React, { forwardRef, useCallback, useState, useEffect, useRef } from 'react';
import type { ElementRef } from 'react';
import styled, { css } from 'styled-components';

import { Target } from '../../client';
import { ZIndices } from '../../styled-components/dark/common';
import type { WinModalBetslip } from '../../types/winModal';
import { pixelToEm } from '../../utils/common';
import Swipe from '../Swipe';
import SwipeReperes from '../SwipeReperes';
import WinModalBet from '../WinModalBet';

const StyledSwipe = styled(Swipe)`
  ${(p) =>
    p.disable
      ? css`
          width: 100%;
          margin: 0;
        `
      : css`
          width: calc(100% - 60px);
          margin: 0 30px;
        `}
  & > div {
    background-color: ${({ theme }) => theme.common.colors.dark2};
  }
`;

const Click = styled.div`
  position: relative;
  height: ${pixelToEm(30)}em;
  cursor: pointer;
  z-index: ${ZIndices.navBar};
`;

const StyledReperes = styled(SwipeReperes)`
  height: 100%;
  pointer-events: none;
`;

type SwipeBetsProps = {
  betslips: Array<WinModalBetslip>;
  setIndex: (index: number) => void;
  onLoad: ({ width: number, height: number }) => void;
  current: number;
};

const SwipeBets = forwardRef<SwipeBetsProps, ElementRef<'div'>>(function SwipeBets(
  { betslips, onLoad, setIndex, current },
  ref,
) {
  const [indexToGo, setIndexToGo] = useState(null);
  const refClick = useRef<ElementRef<'div'> | null>(null);

  const handleClick = useCallback(
    (e) => {
      if (refClick.current) {
        const box = refClick.current.getBoundingClientRect();
        const relX = e.clientX - box.left;
        setIndexToGo(relX < box.width / 2 ? current - 1 : current + 1);
      }
    },
    [current],
  );

  useEffect(() => {
    // reset indexToGo when it's apply
    if (indexToGo === current) {
      setIndexToGo(null);
    }
  }, [current, indexToGo]);

  return (
    <div ref={ref}>
      <StyledSwipe
        setIndex={setIndex}
        disable={betslips.length === 1}
        indexToGo={indexToGo}
        onResize={onLoad}
        useKeyboard={!Target.__MOBILE__}
        useDeportedEvent
      >
        {betslips.map((betslip) => (
          <WinModalBet key={betslip.betslipReference} {...betslip} />
        ))}
      </StyledSwipe>
      {betslips.length > 1 && (
        <Click ref={refClick} onClick={handleClick}>
          <StyledReperes length={betslips.length} current={current} />
        </Click>
      )}
    </div>
  );
});

export default SwipeBets;
